/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DbrBalloonEntity } from '../../models/dbr-balloon-entity';

export interface BalloonsControllerFindOneByCode$Params {
  code: string;
}

export function balloonsControllerFindOneByCode(http: HttpClient, rootUrl: string, params: BalloonsControllerFindOneByCode$Params, context?: HttpContext): Observable<StrictHttpResponse<DbrBalloonEntity>> {
  const rb = new RequestBuilder(rootUrl, balloonsControllerFindOneByCode.PATH, 'get');
  if (params) {
    rb.path('code', params.code, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DbrBalloonEntity>;
    })
  );
}

balloonsControllerFindOneByCode.PATH = '/balloons/bycode/{code}';
